<!--
 * @Desc: 学校新闻
   标签类名，使用-进行分割命名，如page-home、item-form
   标签id，使用小驼峰规则命名，如homeId、itemId
   变量名，使用小驼峰规则命名，如publicPath、wxCode
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-07-17 11:23:09
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-apply">
        <!-- 菜单 -->
        <menuCommon :active="active"></menuCommon>
        <!-- 内容区 -->
        <BreadCrumb :objectData="objectData"></BreadCrumb>
        <div style="text-align: center;margin-top: 30px;">
            <el-button size="medium" @click="$toPath('/Apply?active=' + $route.query.active)">复读生报名</el-button>
            <el-button size="medium" type="primary" style="background-color: #409EFF;border-color: #409EFF;">应届生报名</el-button>
        </div>
        <section class="page-apply-section">
            <div class="container">
                <div class="apply-tips">
                    Tips：报名信息保存后，需在详情页面确认信息后提交，报名状态为“已提交”才算报名成功
                </div>
                <div style="padding-left: 24px;">
                    <el-button @click="toQuery" type="primary" plain>报名查询</el-button>
                    <!-- 
                        status==1 && can_pay==1                  提示:当前状态:已通过审核,请缴费,贴图  
                        status==1 && can_pay==0     提示:请联系学校获取录取通知书
                        status==2        提示:请修改信息
                     -->
                    <span v-if="bmStatus == 1 && copyData.can_pay==1" style="margin-left: 10px;color: rgba(226, 47, 36, 1);">当前状态:已通过审核,请缴费</span>
                    <span v-else-if="bmStatus == 1 && copyData.can_pay==0" style="margin-left: 10px;color: rgba(226, 47, 36, 1);">当前状态:请联系学校获取录取通知书</span>
                    <span v-else-if="bmStatus == 2" style="margin-left: 10px;color: rgba(226, 47, 36, 1);">当前状态:请修改信息</span>
                    <img style="width: 60%;display: block;margin: 20px auto;" v-if="bmStatus == 1 && copyData.can_pay == 1" src="../../public/statics/images/payEnd.jpg">
                </div>
                <div class="collapse-head" style="margin-top: 0">学生基本信息</div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="8">
                            <h1 class="title">学生姓名</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.name"
                                clearable
                                placeholder="请输入学生姓名"
                            ></el-input>
                        </el-col>
                        <el-col :span="8">
                            <h1 class="title">报名类型</h1>
                            <el-select
                                v-model="viewData.bm_type_id"
                                clearable
                                style="width: 100%"
                                placeholder="请选择报名类型"
                            >
                                <el-option
                                    v-for="item in bmTypeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8">
                            <h1 class="title">学生性别</h1>
                            <el-select
                                v-model="viewData.sex"
                                clearable
                                style="width: 100%"
                                placeholder="请选择性别"
                            >
                            <el-option
                                    label="男"
                                    :value="1"
                                >
                                </el-option>
                                <el-option
                                    label="女"
                                    :value="2"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="8">
                            <h1 class="title">身份证号</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.card_num"
                                clearable
                                placeholder="请输入身份证号"
                            ></el-input>
                        </el-col>
                        <el-col :span="8">
                            <h1 class="title">联系方式</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.phone"
                                clearable
                                placeholder="请输入联系方式"
                            ></el-input>
                        </el-col>
                        <el-col :span="8">
                            <h1 class="title">民族</h1>
                            <el-select
                                v-model="viewData.nation_id"
                                filterable
                                clearable
                                style="width: 100%"
                                placeholder="请选择民族"
                            >
                                <el-option
                                    v-for="item in nationList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="8">
                            <h1 class="title">身高(cm)</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.height"
                                clearable
                                placeholder="单位：厘米，保留1位小数"
                            ></el-input>
                        </el-col>
                        <el-col :span="8">
                            <h1 class="title">体重(kg)</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.weight"
                                clearable
                                placeholder="单位：千克，保留1位小数"
                            ></el-input>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="24">
                            <h1 class="title nostar">备注</h1>
                            <el-input
                            type="textarea"
                            placeholder="请输入内容"
                            v-model="viewData.remark"
                            clearable
                            maxlength="255"
                            rows="4"
                            show-word-limit
                            >
                            </el-input>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-head" style="margin-top: 0">学生户口信息</div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="8">
                            <h1 class="title">所在省</h1>
                            <el-select
                                v-model="viewData.hk_sheng"
                                filterable
                                clearable
                                @change="hkSheng"
                                style="width: 100%"
                                placeholder="请选择报名类型"
                            >
                                <el-option
                                    v-for="item in sheng"
                                    :key="item.id"
                                    :label="item.areaname"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8">
                            <h1 class="title">所在市</h1>
                            <el-select
                                v-model="viewData.hk_shi"
                                filterable
                                clearable
                                @change="hkShiChange"
                                style="width: 100%"
                                placeholder="请选择报名类型"
                            >
                                <el-option
                                    v-for="item in hkShi"
                                    :key="item.id"
                                    :label="item.areaname"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8">
                            <h1 class="title">所在区县</h1>
                            <el-select
                                v-model="viewData.hk_qu"
                                filterable
                                clearable
                                style="width: 100%"
                                placeholder="请选择报名类型"
                            >
                                <el-option
                                    v-for="item in hkQu"
                                    :key="item.id"
                                    :label="item.areaname"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-head" style="margin-top: 0">就读学校信息</div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="8">
                            <h1 class="title">所在省</h1>
                            <el-select
                                v-model="viewData.jd_sheng"
                                filterable
                                clearable
                                @change="jdSheng"
                                style="width: 100%"
                                placeholder="请选择报名类型"
                            >
                                <el-option
                                    v-for="item in sheng"
                                    :key="item.id"
                                    :label="item.areaname"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8">
                            <h1 class="title">所在市</h1>
                            <el-select
                                v-model="viewData.jd_shi"
                                filterable
                                clearable
                                @change="jdShiChange"
                                style="width: 100%"
                                placeholder="请选择报名类型"
                            >
                                <el-option
                                    v-for="item in jdShi"
                                    :key="item.id"
                                    :label="item.areaname"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8">
                            <h1 class="title">所在区县</h1>
                            <el-select
                                v-model="viewData.jd_qu"
                                filterable
                                clearable
                                style="width: 100%"
                                placeholder="请选择报名类型"
                            >
                                <el-option
                                    v-for="item in jdQu"
                                    :key="item.id"
                                    :label="item.areaname"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="24">
                            <h1 class="title">学校名称</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.jd_school"
                                clearable
                                placeholder="请输入学籍所在学校名称"
                            ></el-input>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-head" style="margin-top: 0">学籍信息</div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="8">
                            <h1 class="title">所在省</h1>
                            <el-select
                                v-model="viewData.xj_sheng"
                                filterable
                                clearable
                                @change="xjSheng"
                                style="width: 100%"
                                placeholder="请选择报名类型"
                            >
                                <el-option
                                    v-for="item in sheng"
                                    :key="item.id"
                                    :label="item.areaname"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8">
                            <h1 class="title">所在市</h1>
                            <el-select
                                v-model="viewData.xj_shi"
                                filterable
                                clearable
                                @change="xjShiChange"
                                style="width: 100%"
                                placeholder="请选择报名类型"
                            >
                                <el-option
                                    v-for="item in xjShi"
                                    :key="item.id"
                                    :label="item.areaname"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8">
                            <h1 class="title">所在区县</h1>
                            <el-select
                                v-model="viewData.xj_qu"
                                filterable
                                clearable
                                style="width: 100%"
                                placeholder="请选择报名类型"
                            >
                                <el-option
                                    v-for="item in xjQu"
                                    :key="item.id"
                                    :label="item.areaname"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="24">
                            <h1 class="title">学校名称</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.xj_school"
                                clearable
                                placeholder="请输入学籍所在学校名称"
                            ></el-input>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-head" style="margin-top: 0">学生其他信息</div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="24">
                            <h1 class="title">是否班干部</h1>
                            <el-radio-group v-model="viewData.is_leader">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="24">
                            <h1 class="title">建档立卡</h1>
                            <el-radio-group v-model="viewData.is_jiandang">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-head" style="margin-top: 0">家庭信息</div>
                <div style="font-size: 16px;color: #F00;padding-left: 24px;margin-top: 24px;">* 如单亲家庭，父亲信息、母亲信息填写一样。</div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="8">
                            <h1 class="title">父亲姓名</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.father_name"
                                clearable
                                placeholder="请输入父亲姓名"
                            ></el-input>
                        </el-col>
                        <el-col :span="8">
                            <h1 class="title">联系方式</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.father_phone"
                                clearable
                                placeholder="请输入父亲联系方式"
                            ></el-input>
                        </el-col>
                        <el-col :span="8">
                            <h1 class="title">工作单位</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.father_company"
                                clearable
                                placeholder="请输入父亲工作单位"
                            ></el-input>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="8">
                            <h1 class="title">职务</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.father_duty"
                                clearable
                                placeholder="请输入父亲职务"
                            ></el-input>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="8">
                            <h1 class="title">母亲姓名</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.mother_name"
                                clearable
                                placeholder="请输入母亲姓名"
                            ></el-input>
                        </el-col>
                        <el-col :span="8">
                            <h1 class="title">联系方式</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.mother_phone"
                                clearable
                                placeholder="请输入母亲联系方式"
                            ></el-input>
                        </el-col>
                        <el-col :span="8">
                            <h1 class="title">工作单位</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.mother_company"
                                clearable
                                placeholder="请输入母亲工作单位"
                            ></el-input>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="8">
                            <h1 class="title">职务</h1>
                            <el-input
                                style="width: 100%"
                                v-model="viewData.mother_duty"
                                clearable
                                placeholder="请输入母亲职务"
                            ></el-input>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-head" style="margin-top: 0">奥赛相关情况</div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="24">
                            <h1 class="title">是否有奥赛经历</h1>
                            <el-radio-group v-model="viewData.is_aosai">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                </div>
                <div class="collapse-body">
                    <el-row :gutter="32">
                        <el-col :span="24">
                            <h1 class="title">是否有意高中参赛</h1>
                            <el-radio-group v-model="viewData.is_want_aosai">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                </div>

                <div class="btn-hold" style="padding-bottom: 10px;align-items: center;">
                    <el-checkbox v-model="xieyi"></el-checkbox><span @click="xieyiShow = true" style="margin-left: 10px;cursor: pointer;">我已阅读并同意<span style="color:#409eff">《用户协议》</span></span>
                </div>
                <div class="btn-hold">
                    <el-button type="primary" class="btn-cancel" style="border-color:#e22f24;" v-if="viewData.status != 1" @click="resetForm">取 消</el-button>
                    <el-button type="primary" class="btn-sure" style="border-color:#e22f24;" v-if="viewData.status != 1" @click="submit">提 交</el-button>
                </div>
            </div>
        </section>
        <!-- 查询弹层 -->
        <el-dialog title="信息查询" :visible.sync="dialogFormVisible" :center="true" :close-on-click-modal="false">
            <el-form :model="form" label-width="100">
                <el-form-item label="手机号">
                    <el-input v-model="form.phone" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model="form.card_num" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="querySure">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 协议弹层 -->
        <el-dialog title="用户协议" :visible.sync="xieyiShow" :center="true" :close-on-click-modal="false">
            {{ configData.xieyi }}
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="xieyiShow = false">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 页脚 -->
        <footerCommon></footerCommon>
    </div>
</template>

<script>
import menuCommon from "./../components/Common/Menu.vue";
import footerCommon from "./../components/Common/Footer.vue";
import BreadCrumb from "./../components/Common/BreadCrumb.vue";
import ImageUpload from '@/components/image'
export default {
    name: "home",
    data() {
        return {
            // 民族列表
            nationList:[],
            // 报名类型List
            bmTypeList:[],
            // 省数据 学生户口信息 就读学校信息  学籍信息 公用
            sheng:[],
            hkShi:[],
            hkQu:[],
            jdShi:[],
            jdQu:[],
            xjShi:[],
            xjQu:[],
            xieyi:false,//协议是否选中
            xieyiShow:false,
            configData:'',
            bmStatus: '-1',// 报名状态
            dialogFormVisible:false,//查询弹层
            form:{
                phone:'',
                card_num:'',
            },
            // 菜单选中
            active: this.$route.query.active,
            recommendData: {},
            // 栏目详情
            cateData:'',
            // 面包屑展示数据
            objectData: {
                title: "",
                navArray: [],
                thu:''
            },
            copyData:{},
            viewData:{
                id:'',
                name:'',
                sex:'',
                bm_type_id:'',
                card_num:'',
                nation_id:'',
                phone:'',
                height:'',
                weight:'',
                remark:'',
                hk_sheng:'',
                hk_shi:'',
                hk_qu:'',
                jd_sheng:'',
                jd_shi:'',
                jd_qu:'',
                jd_school:'',
                xj_sheng:'',
                xj_shi:'',
                xj_qu:'',
                xj_school:'',
                is_leader:0,
                is_jiandang:0,
                father_name:'',
                father_phone:'',
                father_company:'',
                father_duty:'',
                mother_name:'',
                mother_phone:'',
                mother_company:'',
                mother_duty:'',
                is_aosai:0,
                is_want_aosai:0,
            }
        };
    },
    components: {
        menuCommon,
        footerCommon,
        BreadCrumb,
        ImageUpload
    },
    created() {
        this.getAllSelect()
        this.cateDetail()
        this.getConfig()
    },
    mounted() {
        $("html,body").scrollTop(0);
    },
    beforeDestroy() {},
    methods: {
        init(){},
        // 户口省变动
        hkSheng(val){
            let that = this
            if (!val) {
                that.hkShi = []
                that.hkQu = []
                that.viewData.hk_shi = ''
                that.viewData.hk_qu = ''
                return
            }
            this.$api.index
                .yjApplyAreas({parentid:val})
                .then((res) => {
                    that.hkShi = res.result
                    that.hkQu = []
                    that.viewData.hk_shi = ''
                    that.viewData.hk_qu = ''
                })
                .catch((res) => {
                    console.log(res)
                });
        },
        // 户口市变动
        hkShiChange(val){
            let that = this
            if (!val) {
                that.hkQu = []
                that.viewData.hk_qu = ''
                return
            }
            this.$api.index
                .yjApplyAreas({parentid:val})
                .then((res) => {
                    that.hkQu = res.result
                    that.viewData.hk_qu = ''
                })
                .catch((res) => {
                    console.log(res)
                });
        },
        // 就读省变动
        jdSheng(val){
            let that = this
            if (!val) {
                that.jdShi = []
                that.jdQu = []
                that.viewData.jd_shi = ''
                that.viewData.jd_qu = ''
                return
            }
            this.$api.index
                .yjApplyAreas({parentid:val})
                .then((res) => {
                    that.jdShi = res.result
                    that.jdQu = []
                    that.viewData.jd_shi = ''
                    that.viewData.jd_qu = ''
                })
                .catch((res) => {
                    console.log(res)
                });
        },
        // 就读市变动
        jdShiChange(val){
            let that = this
            if (!val) {
                that.jdQu = []
                that.viewData.jd_qu = ''
                return
            }
            this.$api.index
                .yjApplyAreas({parentid:val})
                .then((res) => {
                    that.jdQu = res.result
                    that.viewData.jd_qu = ''
                })
                .catch((res) => {
                    console.log(res)
                });
        },
        // 学籍省变动
        xjSheng(val){
            let that = this
            if (!val) {
                that.xjShi = []
                that.xjQu = []
                that.viewData.xj_shi = ''
                that.viewData.xj_qu = ''
                return
            }
            this.$api.index
                .yjApplyAreas({parentid:val})
                .then((res) => {
                    that.xjShi = res.result
                    that.xjQu = []
                    that.viewData.xj_shi = ''
                    that.viewData.xj_qu = ''
                })
                .catch((res) => {
                    console.log(res)
                });
        },
        // 学籍市变动
        xjShiChange(val){
            let that = this
            if (!val) {
                that.xjQu = []
                that.viewData.xj_qu = ''
                return
            }
            this.$api.index
                .yjApplyAreas({parentid:val})
                .then((res) => {
                    that.xjQu = res.result
                    that.viewData.xj_qu = ''
                })
                .catch((res) => {
                    console.log(res)
                });
        },
        // 获取所有下拉列表
        getAllSelect() {
            let that = this
            this.$api.index
                .yjApplySelect({})
                .then((res) => {
                    that.nationList = res.result.nation
                    that.bmTypeList = res.result.bm_type
                    that.sheng = res.result.sheng

                    // 报名默认
                    that.viewData.bm_type_id = that.bmTypeList[0].id
                    // 默认户口省市区
                    that.viewData.hk_sheng = that.sheng[0].id
                    this.$api.index
                        .yjApplyAreas({parentid:that.sheng[0].id})
                        .then((res) => {
                            that.hkShi = res.result
                            that.viewData.hk_shi = that.hkShi[0].id

                            this.$api.index
                                .yjApplyAreas({parentid:that.viewData.hk_shi})
                                .then((res) => {
                                    that.hkQu = res.result
                                    that.viewData.hk_qu = that.hkQu[0].id
                                })
                                .catch((res) => {
                                    console.log(res)
                                });
                        })
                        .catch((res) => {
                            console.log(res)
                        });
                    that.viewData.jd_sheng = that.sheng[0].id
                    this.$api.index
                        .yjApplyAreas({parentid:that.sheng[0].id})
                        .then((res) => {
                            that.jdShi = res.result
                            that.viewData.jd_shi = that.jdShi[0].id

                            this.$api.index
                                .yjApplyAreas({parentid:that.viewData.jd_shi})
                                .then((res) => {
                                    that.jdQu = res.result
                                    that.viewData.jd_qu = that.jdQu[0].id
                                })
                                .catch((res) => {
                                    console.log(res)
                                });
                        })
                        .catch((res) => {
                            console.log(res)
                        });
                    that.viewData.xj_sheng = that.sheng[0].id
                    this.$api.index
                        .yjApplyAreas({parentid:that.sheng[0].id})
                        .then((res) => {
                            that.xjShi = res.result
                            that.viewData.xj_shi = that.xjShi[0].id

                            this.$api.index
                                .yjApplyAreas({parentid:that.viewData.xj_shi})
                                .then((res) => {
                                    that.xjQu = res.result
                                    that.viewData.xj_qu = that.xjQu[0].id
                                })
                                .catch((res) => {
                                    console.log(res)
                                });
                        })
                        .catch((res) => {
                            console.log(res)
                        });
                })
                .catch((res) => {
                    console.log(res)
                });
        },
        // 打印通知书
        toPrint(){
            window.open(this.viewData.zip_url)
        },
        // 获取网址信息配置
        getConfig(){
            let that = this
            this.$api.index
                .getConfig({})
                .then((res) => {
                    that.configData = res.result
                })
                .catch((res) => {
                    console.log(res)
                });
        },
        // 栏目详情 面包屑展示
        cateDetail(){
            let that = this
            that.$api.index.cateDetail({id:this.$route.query.active}).then((res) => {
                if (res.code == 200) {
                    that.cateData = res.result
                    that.objectData.title = that.cateData.name
                    that.objectData.navArray = that.cateData.breadcrumb
                    that.objectData.thu = that.cateData.thumb
                }
            })
        },
        // 查询完去缴费
        payment(){
            console.log('去缴费')
            let that = this
            that.$api.index.orderCreate({apply_id:that.viewData.id}).then((res)=>{
                if(res.code == 200) {
                    that.$toPath('/PayType',{
                        id:res.result.id,
                        total_price:res.result.total_price
                    })
                }
            })
        },
        // 查询弹层
        toQuery(){
            this.form= {
                phone:'',
                card_num:'',
            }
            this.dialogFormVisible = true
        },
        // 弹层确认事件
        querySure(){
            let that = this
            that.$api.index.yjApplyDetail(that.form).then((res)=>{
                if(res.code == 200) {
                    that.copyData = JSON.parse(JSON.stringify(res.result))
                    that.bmStatus = that.copyData.status
                    that.xieyi = true

                    that.viewData = res.result
                    that.dialogFormVisible = false

                    // 户口 市区 区县
                    if (that.viewData.hk_sheng) {
                        that.$api.index
                            .yjApplyAreas({parentid:that.viewData.hk_sheng})
                            .then((res) => {
                                that.hkShi = res.result
                            })
                            .catch((res) => {
                                console.log(res)
                            });
                    }
                    if (that.viewData.hk_shi) {
                        that.$api.index
                            .yjApplyAreas({parentid:that.viewData.hk_shi})
                            .then((res) => {
                                that.hkQu = res.result
                            })
                            .catch((res) => {
                                console.log(res)
                            });
                    }
                    // 就读 市区 区县
                    if (that.viewData.jd_sheng) {
                        that.$api.index
                            .yjApplyAreas({parentid:that.viewData.jd_sheng})
                            .then((res) => {
                                that.jdShi = res.result
                            })
                            .catch((res) => {
                                console.log(res)
                            });
                    }
                    if (that.viewData.jd_shi) {
                        that.$api.index
                            .yjApplyAreas({parentid:that.viewData.jd_shi})
                            .then((res) => {
                                that.jdQu = res.result
                            })
                            .catch((res) => {
                                console.log(res)
                            });
                    }
                    // 学籍 市区 区县
                    if (that.viewData.xj_sheng) {
                        that.$api.index
                            .yjApplyAreas({parentid:that.viewData.xj_sheng})
                            .then((res) => {
                                that.xjShi = res.result
                            })
                            .catch((res) => {
                                console.log(res)
                            });
                    }
                    if (that.viewData.xj_shi) {
                        that.$api.index
                            .yjApplyAreas({parentid:that.viewData.xj_shi})
                            .then((res) => {
                                that.xjQu = res.result
                            })
                            .catch((res) => {
                                console.log(res)
                            });
                    }

                    // 审核通过，不能编辑
                    if (that.viewData.status == 1) {
                        $('.page-apply .collapse-body').addClass('noEvents')
                    } else {
                        $('.page-apply .collapse-body').removeClass('noEvents')
                    }
                } else {
                    that.bmStatus = '-1'
                }
            })
        },
        /**
         * @name: 调用接口 提交数据
         * @return {*}
         * @desc:
         */
         submit() {
            if(!this.xieyi){
                // this.$message.error('请阅读并同意用户协议')
                this.$alert('请阅读并同意用户协议', '', {
                    confirmButtonText: '确定',
                    callback: action => {
                    }
                });
                return
            }
            // 调用接口
            console.log(this.viewData);
            let that = this;
            if(that.viewData.id){
                that.$api.index.yjApplyEdit(that.viewData).then((res)=>{
                    if(res.code == 200) {
                        // that.$message.success(res.msg)
                        that.$alert(res.msg, '', {
                            confirmButtonText: '确定',
                            callback: action => {
                            }
                        });
                        that.resetForm()
                    }
                })
                return
            }
            that.$api.index.yjApplySubmit(that.viewData).then((res)=>{
                if(res.code == 200) {
                    that.$alert(res.msg, '', {
                        confirmButtonText: '确定',
                        callback: action => {
                        }
                    });
                    that.resetForm()
                }
            })
        },
        // 清空表单
        resetForm(){
            this.xieyi = false
            this.bmStatus = '-1'
            this.viewData = {
                id:'',
                name:'',
                sex:'',
                bm_type_id:'',
                card_num:'',
                nation_id:'',
                phone:'',
                height:'',
                weight:'',
                remark:'',
                hk_sheng:'',
                hk_shi:'',
                hk_qu:'',
                jd_sheng:'',
                jd_shi:'',
                jd_qu:'',
                jd_school:'',
                xj_sheng:'',
                xj_shi:'',
                xj_qu:'',
                xj_school:'',
                is_leader:0,
                is_jiandang:0,
                father_name:'',
                father_phone:'',
                father_company:'',
                father_duty:'',
                mother_name:'',
                mother_phone:'',
                mother_company:'',
                mother_duty:'',
                is_aosai:0,
                is_want_aosai:0,
            }
            this.getAllSelect()
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.noEvents{
    pointer-events: none;
}
.page-apply {
    background: #f0f2f5 no-repeat top center;
}
/*  */
.page-apply .page-apply-section .container {
    margin-top: 30px;
    margin-bottom: 30px;
    background: #ffffff;
    padding-right: 16px;
}
.page-apply .container .apply-tips {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 16px;
    color: rgba(226, 47, 36, 1);
    padding-top: 19px;
    margin-bottom: 15px;
    padding-left: 24px;
}
.page-apply .container .collapse-head {
    width: 1184px;
    line-height: 56px;
    padding-left: 48px;
    position: relative;
    margin-top: 10px;
    font-weight: 600;
    font-size: 18px;
}
.page-apply .container .collapse-head::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 24px;
    transform: translateY(-50%);
    width: 12px;
    height: 8px;
    background: url(../../public/statics/images/down.png) no-repeat;
}
.page-apply .container .collapse-head::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: rgba(0, 0, 0, 0.1);
}
.page-apply .container .collapse-body {
    width: 1184px;
    padding-left: 24px;
    position: relative;
    margin: 24px 0;
}
.page-apply .container .collapse-body .title {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 10px;
    position: relative;
    padding-left: 12px;
}
.page-apply .container .collapse-body .title::after{
    content: '*';
    position: absolute;
    top: 2px;
    left: 0;
    color: #e22f24;
}
.page-apply .container .collapse-body .title.nostar{
    padding-left: 0;
}
.page-apply .container .collapse-body .title.nostar::after{
    display:none;
}
.page-apply .container .btn-hold {
    display: flex;
    justify-content: center;
    padding-bottom: 30px;
}
.page-apply .container .btn-hold .btn-cancel {
    width: 118px;
    height: 44px;
    background: #e22f24;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: AppleSystemUIFont;
    color: #ffffff;
}
.page-apply .container .btn-hold .btn-sure {
    width: 118px;
    height: 44px;
    background: #e22f24;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: AppleSystemUIFont;
    color: #ffffff;
    margin-left: 15px;
}
</style>